export const selectMainResipes = state => state.main.recipes;
export const selectMainLoad = state => state.main.isLoading;
